import React, { Component } from "react";
import { Player } from 'video-react';
export default class PopUp extends Component {
  handleClick = () => {
   this.props.toggle();
  };
render() {
  return (
   <div className="modalvideo">
<div className="modal_content">
     
     <img src=" " className="Logovideo"/>
     <Player
      fullScreen
      playsInline
      autoPlay 
      poster="http://taktiko.com.mx/shipper/poster.png"
      src="http://taktiko.com.mx/shipper/TheShipper_Updated.mp4"
    />
    <span className="close" onClick={this.handleClick}>SKIP VIDEO</span>
    </div>     
   </div>
  );
 }
}
